import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIText extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  putMessageId = async (
    messageId: UUID,
    { ...body }: types.TextMessageUpdate,
  ): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/text/${messageId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
